// extracted by mini-css-extract-plugin
export default {"launch-your-page-container":"y2EqA","launch-your-page-header":"Icf39","launch-your-page-paragraph":"_Ymrp","launch-your-page-text":"I0EaH"};